import { useStores } from "../../stores/root-store";
import { observer } from "mobx-react";
import _, { add, toNumber } from "lodash";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "react-bootstrap";
import { IModal } from "../../stores";
import { useCallback, useEffect, useState } from "react";
import { ShowAlert } from "../../utils/functions";
import { IAddOnOption, IAddOnOptionMapping } from "../../stores/products";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faPlus } from "@fortawesome/free-solid-svg-icons";

const AddOnForm = observer(({ show, setShowModal }: IModal) => {
  const { addOnOptstore } = useStores();
  const { addOnOptions, editAddOnOption, fetchAddOnOptions, saveAddOnOption } =
    addOnOptstore;
  const [addOnOptionName, setAddOnOptionName] = useState(
    editAddOnOption?.addOnOptionName
  );
  const [addOnOptionPrice, setAddOnOptionPrice] = useState(
    editAddOnOption?.addOnOptionPrice
  );

  const [isFormValid, setIsFormValid] = useState(true);
  const isEditRequest =
    editAddOnOption != null && editAddOnOption.addOnOptionId > 0;

  const validateForm = () => {
    const isValid =
      addOnOptionName && addOnOptionPrice != null && addOnOptionPrice >= 0
        ? true
        : false;

    setIsFormValid(isValid);
  };

  useEffect(() => {
    validateForm();
  }, [addOnOptionName, addOnOptionPrice]);

  const submitCallback = useCallback((res: boolean) => {
    if (res) {
      setShowModal(false);
      fetchAddOnOptions();
      ShowAlert.Success(
        `Add-On Option ${isEditRequest ? "updated" : "added"} successfully.`
      );
    } else {
      ShowAlert.Error("Request failed. Please try again.");
    }
  }, []);

  const handleFormSubmit = () => {
    if (!isFormValid) {
      ShowAlert.Error("One or more field value missing.");
      return;
    }

    saveAddOnOption(
      {
        addOnOptionId: editAddOnOption?.addOnOptionId,
        addOnOptionName: addOnOptionName,
        addOnOptionPrice: addOnOptionPrice,
      },
      submitCallback
    );
  };

  return (
    <Modal show={show} onHide={() => setShowModal(false)}>
      <ModalHeader closeButton>
        <Modal.Title>
          <h5>{isEditRequest ? "Update" : "Add"} Product Add-Ons</h5>
        </Modal.Title>
      </ModalHeader>
      <ModalBody>
        <form>
          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control"
              id="addOnOptTitle"
              placeholder="Option Name"
              value={addOnOptionName || ""}
              onChange={(e) => setAddOnOptionName(e.target.value)}
            />
            <label htmlFor="addOnOptTitle">Add-On Option Name</label>
          </div>
          <div className="form-floating mb-3">
            <input
              type="number"
              className="form-control"
              id="addOnOptPrice"
              placeholder="£"
              value={addOnOptionPrice || ""}
              onChange={(e) => setAddOnOptionPrice(toNumber(e.target.value))}
            />
            <label htmlFor="addOnOptPrice">Price (£)</label>
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <button
          className="btn btn-default flex-fill"
          onClick={handleFormSubmit}
          disabled={!isFormValid}
        >
          {isEditRequest ? (
            <>
              <FontAwesomeIcon icon={faEdit} className="me-2" />
              <span>Update Add-On Option</span>
            </>
          ) : (
            <>
              <FontAwesomeIcon icon={faPlus} className="me-2" />
              <span>Add Add-On Option</span>
            </>
          )}
        </button>
      </ModalFooter>
    </Modal>
  );
});

export default AddOnForm;
